import { render, staticRenderFns } from "./manage-activity-list-item.component.vue?vue&type=template&id=62b3dddf&scoped=true&"
import script from "./manage-activity-list-item.component.vue?vue&type=script&lang=ts&"
export * from "./manage-activity-list-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./manage-activity-list-item.component.vue?vue&type=style&index=0&id=62b3dddf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3dddf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDivider,VExpandTransition,VIcon,VSpacer})
